/**
 * #2496 — the three SPA paths the CP auth server redirects a refused OAuth callback to.
 *
 * ⛔ THE SERVER IS THE AUTHORITY, NOT THIS FILE. `cp-auth-api`'s `REFUSAL_PATHS` in
 * `src/modules/oauth/oauth.service.ts` is what actually chooses the redirect target; this array is
 * the console's copy of the same three literals, because the console cannot import from another
 * service's package. `shell/__tests__/refusal-pages.test.tsx` reads that server file off disk and
 * asserts the two lists agree literal for literal, which is the only mechanical link between them.
 *
 * ⛔ ORDER IS PART OF THE CONTRACT, AND A NEW PATH IS APPENDED LAST. The router pairs a POSITION
 * with a page (`REFUSAL_PATHS[0]` … `[2]` in `CpAdminApp.tsx`), and the server-agreement test
 * compares the server map's values to this array **in order** — so inserting a row anywhere but the
 * end swaps two screens silently on this side and reds on the other. `/access-requested` is stage
 * 2's and is third for that reason.
 *
 * ⛔ IT LIVES UNDER `src/platform/`, NOT `src/shell/`, because two consumers need it and one of
 * them is `platform/auth/return-to.ts` — and `src/platform/` must not import from `src/shell/`
 * (the rule `CpAdminApp.tsx` records for `BASENAME`). The other consumer is the router in
 * `CpAdminApp.tsx`, which imports upward and so is unconstrained.
 *
 * ⚠️ Spelled ONCE. A second copy of `'/sign-in-unavailable'` anywhere in this package is a second
 * place for the console and the server to drift apart with nothing to notice, which is the rule
 * `CONSENT_PATH` states for the same reason.
 */
export const REFUSAL_PATHS = [
  '/sign-in-unavailable',
  '/sign-in-incomplete',
  '/access-requested',
] as const;
